import { memo } from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="term-footer">
      <div className="term-footer-inner">
        <span>&copy; {year} vijoy.paul &mdash; built with React</span>
        <span>
          <a href="https://github.com/vijoy-paul" target="_blank" rel="noopener noreferrer">github</a>
          {' / '}
          <a href="https://linkedin.com/in/vijoy-paul" target="_blank" rel="noopener noreferrer">linkedin</a>
        </span>
      </div>
    </footer>
  );
};

export default memo(Footer);
